// extracted by mini-css-extract-plugin
export default {"wrapper":"c35eedde68707a89","button":"c60cfaed75018d57"};